import { ReactElement } from 'react'
import QuestionMarkIcon from './QuestionMarkIcon'
import styled from 'styled-components'

type MoreInfoLinkProps = {
  helpArticleUrl: string
  inline?: boolean
}

const MoreInfoLink = ({ helpArticleUrl, inline }: MoreInfoLinkProps): ReactElement => (
  <LinkWrapper href={helpArticleUrl} rel="noreferrer" target="_blank" $inline={!!inline}>
    <QuestionMarkIcon />
  </LinkWrapper>
)

const LinkWrapper = styled.a<{ $inline: boolean }>`
  ${({ $inline }) => $inline ? 'display: inline-block;' : 'display: flex;'}
  align-items: center;
`

export default MoreInfoLink
